import React from 'react'
import { connect } from 'react-redux'
import Titulo from '../comum/Titulo'
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada'
import listarPontosEmbarquePorEmpresa from '../../actions/pontoEmbarque/listarPontosEmbarquePorEmpresa'
import excluirPontoEmbarque from '../../actions/pontoEmbarque/excluirPontoEmbarque'
import buscarPontosEmbarqueFiltrado from '../../actions/pontoEmbarque/buscarPontosEmbarqueFiltrado'
import {
  getAdminEmpresa,
  getGestorEmpresa,
  getOperadorEmpresa,
  getGestorOperacoes,
  PERFIL_ADMIN
} from '../../security/securityContext'
import Autorizacao from '../../security/Autorizacao'
import { showSuccessMsg, showAlertMsg } from '../../util/messagesUtil'
import ModalCadastrarPontoEmbarque from './ModalCadastrarPontoEmbarque'
import PainelFiltrosPontosEmbarque from './PainelFiltrosPontosEmbarque'

export class PainelGerenciarPontosEmbarque extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cidadeExpandida: null,
      cidadeSelecionadaModal: null,
      pontoEditando: null,
      modalAberta: false,
      pontoExcluindo: null
    }
  }

  componentDidMount() {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarPontosEmbarquePorEmpresa(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate(prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarPontosEmbarquePorEmpresa(this.props.empresaSelecionada.id)
      this.setState({ cidadeExpandida: null })
      return
    }
    if (this.props.filtrosAdicionadosPontoEmbarque !== prevProps.filtrosAdicionadosPontoEmbarque) {
      const { empresaSelecionada, filtrosAdicionadosPontoEmbarque } = this.props
      if (!empresaSelecionada) return
      if (filtrosAdicionadosPontoEmbarque.length === 0) {
        this.props.listarPontosEmbarquePorEmpresa(empresaSelecionada.id)
      } else {
        this.props.buscarPontosEmbarqueFiltrado(empresaSelecionada.id, 1, 50, filtrosAdicionadosPontoEmbarque)
      }
    }
  }

  recarregar() {
    this.props.listarPontosEmbarquePorEmpresa(this.props.empresaSelecionada.id)
  }

  abrirModal(cidade) {
    this.setState({ cidadeSelecionadaModal: cidade || null, modalAberta: true })
  }

  fecharModal() {
    this.setState({ modalAberta: false, cidadeSelecionadaModal: null })
    this.recarregar()
  }

  toggleCidade(cidadeId) {
    this.setState(prev => ({
      cidadeExpandida: prev.cidadeExpandida === cidadeId ? null : cidadeId
    }))
  }

  excluirPonto(ponto) {
    this.props.excluirPontoEmbarque(ponto.id)
      .then(() => {
        showSuccessMsg('Ponto de embarque excluído com sucesso')
        this.recarregar()
      })
      .catch(() => showAlertMsg('Não foi possível excluir. Este ponto está vinculado a trechos.'))
  }

  pontosDaLista() {
    const temFiltro = (this.props.filtrosAdicionadosPontoEmbarque || []).length > 0
    if (temFiltro) {
      return (this.props.pontoEmbarqueFiltrado && this.props.pontoEmbarqueFiltrado.pontos) || []
    }
    return this.props.pontosEmbarque || []
  }

  agruparPorCidade() {
    const grupos = {}
    this.pontosDaLista().forEach(ponto => {
      const chave = ponto.cidadeId
      if (!grupos[chave]) {
        grupos[chave] = { cidadeId: ponto.cidadeId, nomeCidade: ponto.nomeCidade, uf: ponto.uf, pontos: [] }
      }
      grupos[chave].pontos.push(ponto)
    })
    return Object.values(grupos).sort((a, b) => a.nomeCidade.localeCompare(b.nomeCidade))
  }

  renderPontos(pontos) {
    const cidadeRef = pontos[0]
      ? { id: pontos[0].cidadeId, nome: pontos[0].nomeCidade, uf: pontos[0].uf }
      : null

    return (
      <div className="vx-pontos-painel">
        <div className="vx-table-card" style={{ borderRadius: 0, boxShadow: 'none', borderTop: '1px solid #f0f0f0' }}>
          <div className="vx-table-scroll">
            {pontos.length === 0 ? (
              <div className="vx-empty-state" style={{ padding: '24px 20px' }}>
                <i className="material-icons" style={{ fontSize: 32 }}>location_off</i>
                <p>Nenhum ponto cadastrado para esta cidade.</p>
              </div>
            ) : (
              <table className="vx-table-left">
                <thead>
                  <tr>
                    <th style={{ width: 80 }}>ID</th>
                    <th>Ponto de embarque</th>
                    <th style={{ width: 60 }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {pontos.map(ponto => (
                    <tr key={ponto.id}>
                      <td style={{ color: '#aaa', fontSize: 12 }}>{ponto.id}</td>
                      <td style={{ fontWeight: 600 }}>{ponto.nome}</td>
                      <td>
                        <button
                          type="button"
                          className="vx-act-btn vx-act-btn--delete"
                          title="Excluir ponto"
                          onClick={() => this.excluirPonto(ponto)}
                        >
                          <span className="material-icons">delete</span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
        <div style={{ padding: '8px 16px 12px' }}>
          <button
            type="button"
            className="vx-btn-incluir"
            onClick={() => this.abrirModal(cidadeRef)}
          >
            <i className="material-icons" style={{ fontSize: 14 }}>add</i>
            Adicionar ponto
          </button>
        </div>
      </div>
    )
  }

  renderLinhaCidade(grupo) {
    const expandida = this.state.cidadeExpandida === grupo.cidadeId
    const totalPontos = grupo.pontos.length

    return (
      <div key={grupo.cidadeId} className={`vx-row-item${expandida ? ' vx-row-item--selected' : ''}`}>
        <div className="vx-row-item-inner vx-row-item-inner--ponto-embarque">
          <div className="vx-row-cell" style={{ color: '#aaa', fontSize: 12 }}>
            <span className="vx-row-cell-label">ID</span>
            {grupo.cidadeId}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Cidade</span>
            <span style={{ fontWeight: 600 }}>{grupo.nomeCidade}</span>
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Estado</span>
            <span className="vx-row-badge vx-row-badge--ok">{grupo.uf}</span>
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Pontos</span>
            <span style={{ fontSize: 12, color: '#666' }}>
              {totalPontos} {totalPontos === 1 ? 'ponto' : 'pontos'}
            </span>
          </div>
          <div className="vx-row-cell" style={{ display: 'flex', gap: 4, justifyContent: 'flex-end' }}>
            <button
              type="button"
              className="vx-act-btn vx-act-btn--neutral"
              title={expandida ? 'Recolher' : 'Ver pontos de embarque'}
              onClick={() => this.toggleCidade(grupo.cidadeId)}
            >
              <span className="material-icons">{expandida ? 'expand_less' : 'expand_more'}</span>
            </button>
            <button
              type="button"
              className="vx-act-btn vx-act-btn--edit"
              title="Adicionar ponto de embarque"
              onClick={() => this.abrirModal({ id: grupo.cidadeId, nome: grupo.nomeCidade, uf: grupo.uf })}
            >
              <span className="material-icons">add_location_alt</span>
            </button>
          </div>
        </div>
        {expandida && this.renderPontos(grupo.pontos)}
      </div>
    )
  }

  exibir() {
    const grupos = this.agruparPorCidade()
    if (grupos.length === 0) {
      return (
        <div className="vx-empty-state">
          <i className="material-icons">location_city</i>
          <p>Nenhum ponto de embarque cadastrado para esta empresa.</p>
        </div>
      )
    }
    return (
      <div className="vx-list-container">
        <div className="vx-list-header vx-list-header--ponto-embarque">
          <div className="vx-list-header-cell">ID</div>
          <div className="vx-list-header-cell">Cidade</div>
          <div className="vx-list-header-cell">Estado</div>
          <div className="vx-list-header-cell">Pontos</div>
          <div className="vx-list-header-cell" style={{ textAlign: 'right' }}>Ações</div>
        </div>
        {grupos.map(g => this.renderLinhaCidade(g))}
      </div>
    )
  }

  render() {
    return (
      <Autorizacao
        perfisPermitidos={[
          PERFIL_ADMIN,
          getAdminEmpresa(this.props.empresaSelecionada ? this.props.empresaSelecionada.id : null),
          getGestorEmpresa(this.props.empresaSelecionada ? this.props.empresaSelecionada.id : null),
          getOperadorEmpresa(this.props.empresaSelecionada ? this.props.empresaSelecionada.id : null),
          getGestorOperacoes(this.props.empresaSelecionada ? this.props.empresaSelecionada.id : null)
        ]}
        empresaSelecionada={this.props.empresaSelecionada}
      >
        <div className="container-padrao">
          <Titulo texto="Gerenciar Pontos de Embarque" urlRetorno="/" />

          <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
            <div style={{ maxWidth: 340, marginBottom: 16 }}>
              <CampoSelecionarEmpresa />
            </div>
          </Autorizacao>

          <div className="vx-page-toolbar" style={{ marginBottom: 12 }}>
            <span />
            <button
              type="button"
              className="vx-toolbar-btn"
              onClick={() => this.abrirModal(null)}
            >
              <span className="material-icons" style={{ fontSize: 16 }}>add_location</span>
              Criar pontos de embarque
            </button>
          </div>

          <PainelFiltrosPontosEmbarque />

          <div className="vx-table-card">
            {this.exibir()}
          </div>
        </div>

        {this.state.modalAberta && (
          <ModalCadastrarPontoEmbarque
            empresaId={this.props.empresaSelecionada ? this.props.empresaSelecionada.id : null}
            cidadePreSelecionada={this.state.cidadeSelecionadaModal}
            onFechar={() => this.fecharModal()}
          />
        )}
      </Autorizacao>
    )
  }
}

export const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
  pontosEmbarque: state.pontosEmbarque,
  filtrosAdicionadosPontoEmbarque: state.filtrosAdicionadosPontoEmbarque,
  pontoEmbarqueFiltrado: state.pontoEmbarqueFiltrado
})

export default connect(mapStateToProps, {
  listarPontosEmbarquePorEmpresa,
  excluirPontoEmbarque,
  buscarPontosEmbarqueFiltrado
})(PainelGerenciarPontosEmbarque)
